import { faExclamationCircle, faExclamationTriangle, faPen, faPlus, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { Formik } from 'formik';
import React, { useContext } from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import Message from '../../components/Messages/Message';
import Variables from '../../config/global-variables';
import { AuthContext } from '../../hooks/contexts/AuthContext';
import Layoutes from '../../layouts/Layouts'
import SubjectSchema from '../../schemas/subject.schema';

const SeriesPage = () => {
    const user = useContext(AuthContext);

    const [toggleModal, setToggleModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("Add Series");
    const [modalMode, setModalMode] = useState("adding");

    const [seriesId, setSeriesId] = useState(null);
    const [series, setSeries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingError, setLoadingError] = useState(null);

    const [formSuccess, setFormSucces] = useState(null);
    const [formError, setFormError] = useState(null);
    const [formLoading, setFormLoading] = useState(false);

    const [arabicName, setArabicName] = useState("");
    const [englishName, setEnglishName] = useState("");

    const handleAddSeries = () => {
        setModalMode("adding")
        setModalTitle("Add new level");
        setArabicName("");
        setEnglishName("");
        setToggleModal(true);
    }

    const handleEditSeries = (id, index) => {
        setSeriesId(id);
        setArabicName(series[index].arabicName);
        setEnglishName(series[index].englishName);
        setModalMode("editing");
        setModalTitle("Edit Level ", index);
        setToggleModal(true);
    }

    const handleCancelModal = () => {
        setToggleModal(false);
    }

    const handleDeleteSeries = async (id, index) => {
        const result = window.confirm("Are you sure?");
        if (result) {
            try {
                const response = await axios.delete(`${Variables.domainName}/api/bookSeries/${id}`, {
                    headers : {
                        "Content-Type" : "application/json",
                        "x-auth-token" : user.token,
                    }
                })
                if (response.data.success) {
                    setSeries(series.filter((element, index) => element._id !== id ))
                    alert("Series deleted successfully");
                } else {
                    alert("Something went wrong");
                }
            } catch (error) {
                alert("Something went wrong");
            }
            
        }
    }

    const handleSubmitAddition = async (data) => {
        setFormLoading(true);
        if (modalMode === "adding") {
            try {
                const response = await axios.post(`${Variables.domainName}/api/bookSeries`, {
                    arabicName : data.arabicName,
                    englishName : data.englishName,
                }, {
                    headers : {
                        "Content-Type" : "application/json",
                        "x-auth-token" : user.token,
                    }
                })
                if (response.data.success) {
                    setFormLoading(false);
                    setFormError(null);
                    setSeries([...series, {
                        arabicName : response.data.data.arabicName,
                        englishName : response.data.data.englishName,
                        _id : response.data.data._id,
                    }])
                    setFormSucces("Book series added successfully");
                    setTimeout(() => {
                        setFormSucces(null);
                        setToggleModal(false);
                    }, 2000)
                } else {
                    setFormSucces(null);
                    setFormError("Something went wrong!");
                    setFormLoading(false);
                }
            } catch (error) {
                setFormSucces(null);
                setFormError("Something went wrong!");
                setFormLoading(false);
            }
        } else {
            try {
                const response = await axios.put(`${Variables.domainName}/api/bookSeries/${seriesId}`, {
                    arabicName : data.arabicName,
                    englishName : data.englishName,
                }, {
                    headers : {
                        "Content-Type" : "application/json",
                        "x-auth-token" : user.token,
                    }
                })
                if (response.data.success) {
                    setFormLoading(false);
                    setFormError(null);
                    setSeries(series.map((element, index) => {
                        if (element._id === seriesId) {
                            return {
                                englishName : response.data.data.englishName,
                                arabicName : response.data.data.arabicName,
                                _id : response.data.data._id,
                            }
                        } else {
                            return element;
                        }
                    }))
                    setFormSucces("Series updated successfully");
                    setTimeout(() => {
                        setFormSucces(null);
                        setToggleModal(false);
                    }, 2000);
                } else {
                    setFormError("Something went wrong");
                    setFormSucces(false);
                    setFormLoading(false);
                }
            } catch (error) {
                setFormError("Something went wrong");
                setFormSucces(false);
                setFormLoading(false);
            }
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${Variables.domainName}/api/bookSeries`, {
                    headers : {
                        "Content-Type" : "application/json",
                        "x-auth-token" : user.token,
                    }
                })
                if (response && response.data.success) {
                    setSeries(response.data.data);
                    setLoadingError(null);
                    setLoading(false);
                } else {
                    setSeries([]);
                    setLoadingError("There are no Series");
                    setLoading(false);
                }
            } catch (error) {
                setSeries([]);
                setLoadingError("Something went wrong");
                setLoading(false);
            }
        }
        fetchData();
    }, [user])

    return (
        <Layoutes title={"Book series"}>
            <div className={`modal ${toggleModal ? "active" : ""}`}>
                <Formik
                    initialValues={{ englishName : "", arabicName : ""}}
                    validationSchema={SubjectSchema}
                    onSubmit={(values, actions) => handleSubmitAddition(values)}
                >
                {
                props => (
                <form className="modal-form" onSubmit={props.handleSubmit} >
                    {
                    formLoading ?
                    <div className="form-loading-container">
                        <FontAwesomeIcon icon={faSpinner} className="loading-icon" />
                    </div> :
                    ""
                    }
                    <h2 className="title">{modalTitle}</h2>
                    {
                    formError ?
                    <div className="error-wrapper">
                        <Message text={formError} type={"error"} /> 
                    </div> :
                    formSuccess ?
                    <div className="error-wrapper">
                        <Message text={formSuccess} type={"success"} />
                    </div> :
                    ""
                    }                    <div className="form-group">
                        <label htmlFor="enName">English Name :</label>
                        <input 
                            // id='enName'
                            type="text" 
                            className="form-control"
                            value={props.values.englishName}
                            onChange={props.handleChange}
                            onBlur={props.handleBlur}
                            placeholder={englishName}
                            name="englishName"
                        />
                        {props.errors.englishName && <div className="error-text">{props.errors.englishName}</div>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="arName">Arabic Name :</label>
                        <input 
                            // id="arName"
                            type="text"
                            className="form-control"
                            value={props.values.arabicName}
                            onChange={props.handleChange}
                            onBlur={props.handleBlur}
                            placeholder={arabicName}
                            name={"arabicName"}
                        />
                        {props.errors.arabicName && <div className="error-text">{props.errors.arabicName}</div>}
                    </div>
                    <div className="form-button-group">
                        <button 
                            type="button" 
                            className="cancel-button"
                            onClick={handleCancelModal}
                        >
                            Cancel
                        </button>
                        <button type="submit" className="submit-button">
                            Submit
                        </button>
                    </div>
                </form>
                )
                }
                </Formik>
            </div>
            <div className="wrapper">
                <button 
                    type="button" 
                    className="button primary-button larg-button"
                    onClick={handleAddSeries}
                >
                    <FontAwesomeIcon icon={faPlus} />
                    <span>Add new Series</span>
                </button>
                {
                loadingError ?
                <div className="loading-container">
                    <FontAwesomeIcon icon={faExclamationCircle} className="error-icon" />
                    <h3 className="danger-text">{loadingError}</h3>
                </div> :
                loading ?
                <div className="loading-container">
                    <div className="loading-icon">
                        <FontAwesomeIcon icon={faSpinner} />
                    </div>
                </div> :
                series.length <= 0 ?
                <div className="loading-container">
                    <FontAwesomeIcon icon={faExclamationTriangle} className="not-found-icon" />
                    <h3 className="primary-text">There are no book series</h3>
                </div> :
                <table className="subjects-table">
                    <thead className="header">
                        <tr>
                            <th>English Name</th>
                            <th>Arabic Name</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        
                    {
                    series.map((element, index) => (
                        <tr key={index}>
                            <td>{element.englishName}</td>
                            <td>{element.arabicName}</td>
                            <td>
                                <button 
                                    type="button" 
                                    className="button primary-button"
                                    onClick={() => handleEditSeries(element._id, index)}
                                >
                                    <FontAwesomeIcon icon={faPen} />
                                </button>
                                <button 
                                    type="button" 
                                    className="button danger-button"
                                    onClick={() => handleDeleteSeries(element._id, index)}
                                >
                                    <FontAwesomeIcon icon={faTrash} />
                                </button>
                            </td>
                        </tr>
                    ))
                    }
                    </tbody>
                </table>
                }
            </div>
        </Layoutes>
    )
}

export default SeriesPage;